// extracted by mini-css-extract-plugin
export default {"elevators":"elevators___mflKU","elevator":"elevator___i5Xlp","elevatorItem":"elevatorItem___efaQj","elevatorIcon":"elevatorIcon___kBTmp","elevatorLabel":"elevatorLabel___FnUqf"};